module.exports = __webpack_public_path__ + "img/BTNChestOfGold.e2a6fb1a.png";